import { useEffect } from "react";
import { Profile } from "@/components/admin/contact-details/types";

export const useContactJsonLd = (profile: Profile | null) => {
  useEffect(() => {
    if (!profile) return;
    
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Person",
      "identifier": profile.id,
      "givenName": profile.first_name,
      "familyName": profile.last_name,
      "email": profile.email,
      "telephone": profile.phone,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": profile.street,
        "addressLocality": profile.city,
        "addressRegion": profile.state,
        "postalCode": profile.zip_code,
        "addressCountry": "US"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [profile]);
};